package com.trevorwiebe.timesheet.calendar.presentation.uiHelper

import com.trevorwiebe.timesheet.core.domain.model.TimeOffRequestModel

data class TimeOffRequestUi (
    val request: TimeOffRequestModel,
    val employeeName: String?
)